import React from 'react';
import './banner.css';
import { Carousel } from 'react-bootstrap';
import banner1 from '../../images/banner/banner.jpg';
import banner2 from '../../images/banner/banner-2.jpg';
import banner3 from '../../images/banner/banner-3.jpg';


const Banner = () => {
    return (
        <div>
            <Carousel fade>
  <Carousel.Item>
    <img
      className="d-block w-100"
      style={{height:'540px'}} src={banner1}
      alt="First slide"
    />
    <Carousel.Caption>
      <div className="title">
        <h3>Travel With Us</h3>
        <p>ENJOY - ADVENTURE</p>
      </div>
    </Carousel.Caption>
  </Carousel.Item>
  <Carousel.Item>
    <img
      className="d-block w-100"
      style={{height:'540px'}} src={banner2}
      alt="Second slide"
    />

    <Carousel.Caption>
      <div className="title">
      <h3>Travel With Us</h3>
      <p>ENJOY - MOUNTAIN</p>
      </div>
    </Carousel.Caption>
  </Carousel.Item>
  <Carousel.Item>
    <img
      className="d-block w-100"
      style={{height:'540px'}} src={banner3}
      alt="Third slide"
    />

    <Carousel.Caption>
     <div className="title">
     <h3>Travel With Us</h3>
      <p>ENJOY - HOLYDAY</p>
     </div>
    </Carousel.Caption>
  </Carousel.Item>
</Carousel>
        </div>
    );
};

export default Banner;